import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import { BiError } from "react-icons/bi";
import { TbTicket } from "react-icons/tb";
import { useTranslation } from "react-i18next";
interface IProps {
  ticket: Ticket;
  handleSetOpenDayChoose: () => void;
}

const TicketNoExercise: React.FC<IProps> = ({ ticket, handleSetOpenDayChoose }: IProps) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="future-ticket flex-between-center">
        <div className="future-ticket-text flex-start-center">
          <div className="future-ticket-mini-calendar future-mini-calendar-cancel flex-center-center">
            <BiError className="cancel-info" />
          </div>

          <div className="future-ticket-text-details">
            <h3 className="cancel-info">{t("odwolales_wizyte")}</h3>
            <div className=" ticket-name flex-start-center">
              <TbTicket className="icon" /> <b>{ticket.name}</b>
            </div>
          </div>
        </div>
        <div className="future-ticket-buttons-line">
          <div className="alert alert-red">{t("aby_wykorzystac_bilet_wybierz_termin")}</div>
          {ticket.name !== "REZERWACJA" &&
        
          <button
            onClick={() => handleSetOpenDayChoose()}
            className="button medium padding-medium button-fill-background-main full-button"
          >
            {t("zmien_termin")}
          </button>}
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketNoExercise;
